import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getServicePayments = serviceId =>
  call(websocketFetch, 'get_service_payments', { service_id: serviceId });
